// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"128a776c","970":"419a32dd"}[chunkId] + ".chunk.js";
};